import * as React from 'react';

const SvgIconRadiobuttonChecked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18zm0-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
      fill="currentColor"
    />
  </svg>
);

export default SvgIconRadiobuttonChecked;
